"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractTerms = class UcContractTerms extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    filterItems(...args) {
        return _.sortBy(args[0], p => this.isTermStale(p) ? "_" + p.name : p.name);
    }
    isTermStale(...args) {
        const [term] = args;
        return term.valid_to && this.$fn.parseISODate(term.valid_to) < this.today;
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    today;
    async $$load_today() {
        return new Date();
    }
    displayHelper;
    ux;
    dataMembers = ['today', 'displayHelper', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                today: null,
                displayHelper: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_8990_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_8989_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8320016629450276_showModal_8988_getActionArgs($event) {
        return {
            name: "ContractTermEditor",
            props: {
                mode: "add",
                contract: this.contract,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3577443900630089_emit_8994_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3577443900630089_close_8993_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_3577443900630089_showModal_8992_getActionArgs($event) {
        return {
            name: "ContractTermEditor",
            props: {
                mode: "edit",
                contract: this.contract,
                term: _.cloneDeep($event.scope.term),
            },
        };
    }
    async evh_3577443900630089_clickPreventStop(event, scope) {
        return await this.actions.evh_3577443900630089_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8986 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8985 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8986,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8985],
        });
        const act_8320016629450276_emit_8990 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_8990_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_8320016629450276_close_8989 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_8990,
            event: "close",
            when: this.evh_8320016629450276_close_8989_getWhen,
            displayName: "emitReload",
        });
        const act_8320016629450276_showModal_8988 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_8988_getActionArgs,
            events: [evh_8320016629450276_close_8989],
        });
        const evh_8320016629450276_clickPreventStop_8987 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_8988,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_8987],
        });
        const act_3577443900630089_emit_8994 = new core_1.actions.EmitAction({
            actionArgs: this.act_3577443900630089_emit_8994_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_3577443900630089_close_8993 = new core_1.actions.EventHandlerImpl({
            action: act_3577443900630089_emit_8994,
            event: "close",
            when: this.evh_3577443900630089_close_8993_getWhen,
            displayName: "emitReload",
        });
        const act_3577443900630089_showModal_8992 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3577443900630089_showModal_8992_getActionArgs,
            events: [evh_3577443900630089_close_8993],
        });
        const evh_3577443900630089_clickPreventStop_8991 = new core_1.actions.EventHandlerImpl({
            action: act_3577443900630089_showModal_8992,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_3577443900630089_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3577443900630089_clickPreventStop_8991],
        });
        return {
            act_7315092382398562_reloadComponentData_8986,
            evh_7315092382398562_reload_8985,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_8990,
            evh_8320016629450276_close_8989,
            act_8320016629450276_showModal_8988,
            evh_8320016629450276_clickPreventStop_8987,
            evh_8320016629450276_clickPreventStop,
            act_3577443900630089_emit_8994,
            evh_3577443900630089_close_8993,
            act_3577443900630089_showModal_8992,
            evh_3577443900630089_clickPreventStop_8991,
            evh_3577443900630089_clickPreventStop,
            emitReload: act_3577443900630089_emit_8994,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractTerms.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractTerms.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractTerms.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractTerms.prototype, "onReadonly", null);
UcContractTerms = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractTerms);
exports.default = UcContractTerms;
vue_property_decorator_1.Vue.component("UcContractTerms", UcContractTerms);
